module.exports = __webpack_public_path__ + "assets/img/chartCard-title.8488238e.svg";